import { render, staticRenderFns } from "./CreateSupplierBreadCrumbs.vue?vue&type=template&id=2becd793"
import script from "./CreateSupplierBreadCrumbs.vue?vue&type=script&lang=js"
export * from "./CreateSupplierBreadCrumbs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports